export class DeliveryContactModel {
    firstName: string;
    lastName: string;
    secondLastName: string;
    email: string;
    address: string;
    city: string;
    state: string;
    zip: string;
	phone: string;
	provinceCode: string;
	municipeCode: string;
	country: string;
}
